import { clientApi } from 'api';
import { SearchQuery } from 'dashboard/_redux/actions/users';
import { ICategoryTour } from 'client/models/ICategoryTour';

const baseUrl = '/category-tours';

export const getAllCategoryTours = (isServer = false) => async (
  searchQuery: SearchQuery<ICategoryTour>,
) => {
  const response = await clientApi.get(`${baseUrl}`, { params: searchQuery });

  // Transformer la réponse au format PaginatedResponse attendu par le DataTable
  const { categoryTours = [], total = 0 } = response.data;
  
  return {
    items: categoryTours,
    totalItems: total,
    currentPage: searchQuery.page || 1,
    totalPages: Math.ceil(total / (searchQuery.limit || 10)),
  };
};

export const getCategoryTourById = (isServer = false) => async (id: string) => {
  const { data } = await clientApi.get<{ categoryTour: ICategoryTour }>(
    `${baseUrl}/${id}`,
  );

  return data.categoryTour;
};

export const updateCategoryTour = () => async (
  categoryTourData: Partial<ICategoryTour>,
  categoryTourId?: string,
) => {
  const response = await clientApi.put(
    `${baseUrl}/${categoryTourId}`,
    categoryTourData,
  );

  return response.data.categoryTour;
};

export const deleteCategoryTourById = () => async (categoryTourId: string) => {
  await clientApi.delete(`${baseUrl}/${categoryTourId}`);
};

export const createCategoryTour = () => async (
  categoryTourData: { name: string; description: string },
) => {
  const response = await clientApi.post(`${baseUrl}`, categoryTourData);

  return response.data.categoryTour;
};
